<template>
    <el-form ref="form" :model="gxClassroom" :rules="rules" label-width="150px">
        <el-form-item label="模式選擇" >
            <el-radio-group v-model="mode" @change="onSwitch">
                <el-radio-button label="insert">新增</el-radio-button>
                <el-radio-button label="change">異動</el-radio-button>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="場地"  v-if="mode === 'change'">
            <el-select v-model="selectedId" placeholder="請選擇場地" @change="onSelect">
                <el-option
                        v-for="room in rooms"
                        :key="room.id"
                        :label="room.name + (room.isHidden ? '（已隱藏）' : '')"
                        :value="room.id"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="name" label="名稱">
            <el-input
                    v-model="gxClassroom.name"
                    :disabled="!selectedId && inChangeMode"
                    placeholder="請輸入名稱"
            ></el-input>
        </el-form-item>
        <el-form-item prop="ncutRoomId" label="年豐教室編號">
            <el-select
                    v-model="gxClassroom.ncutRoomId"
                    :disabled="!selectedId && inChangeMode"
                    placeholder="請選擇編號"
                    @change="ncutRoomSelect"
            >
                <el-option
                        v-for="room in ncutRooms"
                        :key="room.id"
                        :value="room.id"
                        :label="ncutRoom(room)"
                >
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item v-if="inChangeMode" label="申請人可見性">
            <el-switch
                    v-model="gxClassroom.isHidden"
                    active-text="已隱藏，僅管理者可使用"
                    inactive-text="開放申請"
                    aria-label="教室申請人可見性"
            ></el-switch>
            <div aria-live="polite">
                目前狀態：{{gxClassroom.isHidden ? '已隱藏，申請人無法查詢或借用' : '開放申請'}}
            </div>
        </el-form-item>
        <el-button :disabled="!selectedId && inChangeMode" @click="onSubmit">
            {{inChangeMode ? '更新' : '新增'}}
        </el-button>
        <el-button
                v-if="inChangeMode"
                :disabled="!selectedId && inChangeMode"
                @click="onDelete"
        >
            刪除
        </el-button>
    </el-form>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex';

    const {mapState, mapActions} = createNamespacedHelpers('setting');
    const defaultGxClassroom = {
        id: 0,
        name: '',
        ncutRoomId: '',
        isHidden: false,
    };
    export default {
        name: 'RoomSetting',
        data: () => ({
            gxClassroom: {...defaultGxClassroom},
            selectedId: undefined,
            rules: {
                ncutRoomId: [
                    {required: true, message: '年豐教室編號'}
                ],
                name: [
                    {required: true, message: '請輸入名稱', trigger: 'blur'}
                ]
            },
            mode: 'insert'
        }),
        computed: {
            ...mapState(['rooms', 'ncutRooms']),
            inChangeMode() {
                return this.mode === 'change';
            }
        },
        methods: {
            ...mapActions({
                getNcutRooms: 'getNcutRoomsAction',
                deleteRoom: 'deleteRoomAction',
                insertRoom: 'insertRoomAction',
                updateRoom: 'updateRoomAction',
            }),
            onSelect(id) {
                this.gxClassroom = {...this.rooms.find(r => r.id === id)};
            },
            ncutRoom({id, name}){
              if(!id) return '';

              return `${name}(${id})`;
            },
            onSwitch(){
                this.selectedId = undefined;
                this.gxClassroom = {...defaultGxClassroom};
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            },
            clear(){
                this.gxClassroom = {...defaultGxClassroom};
                this.selectedId = undefined;
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                    //this.$refs.form.resetFields();
                });
            },
            async onDelete(){
                try {
                    await this.$confirm('確定刪除嗎?',{
                        type: 'warning',
                    });
                    const{success} = await this.deleteRoom(this.selectedId);
                    if(success){
                        this.$message({
                            type: 'success',
                            message: '刪除成功'
                        });
                        this.clear();
                    } else{
                        this.$message({
                            type: 'warning',
                            message: '刪除失敗，請重試一次'
                        });
                    }
                }catch (e) {
                    if(e !== 'cancel'){
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },

            async onSubmit(){
                const {form} = this.$refs;
                form.validate(async (valid) => {
                    try {
                        if(valid){
                            if(this.inChangeMode){

                                //do update
                                const {success} = await this.updateRoom(this.gxClassroom);
                                if (success) {
                                    this.$message({
                                        message: '異動成功',
                                        type: 'success'
                                    });
                                } else {
                                    this.$message({
                                        message: '異動失敗，請重試一次',
                                        type: 'warning'
                                    });
                                }
                            } else{
                                //do insert
                                const {success} = await this.insertRoom(this.gxClassroom);
                                if (success) {
                                    this.$message({
                                        message: '新增成功',
                                        type: 'success'
                                    });
                                    this.clear();
                                } else {
                                    this.$message({
                                        message: '新增失敗，請重試一次',
                                        type: 'warning'
                                    });
                                }
                            }
                        }
                    } catch (_) {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                });
            },

            ncutRoomSelect(value){
                this.gxClassroom.name = (this.ncutRooms.find(r => r.id === value) || {name : ''}).name;
            }
        },
        async created() {
            await this.getNcutRooms();
        }
    }
</script>

<style scoped>

</style>
